import {createSelector} from 'reselect';
import attributes from '../../tracking/attributes';
import {getDeliveryGroups} from './DeliveryOptionsSelectors';

export default createSelector(
  [getDeliveryGroups],
  deliveryGroups => deliveryGroups?.flatMap(deliveryGroup => deliveryGroup.deliveryOptions)?.map(
    deliveryOption => [attributes.getAttribute(
      `deliveryOptionMaxDeliveryDays--${deliveryOption?.id}`,
      deliveryOption?.maximumDeliveryDays || '',
    ), attributes.getAttribute(
      `deliveryOptionMinDeliveryDays--${deliveryOption?.id}`,
      deliveryOption?.minimumDeliveryDays || '',
    )],
  )?.flat(),
);
